import { render } from "./ExistingClient.vue?vue&type=template&id=cff5cbaa&scoped=true"
import script from "./ExistingClient.vue?vue&type=script&lang=js"
export * from "./ExistingClient.vue?vue&type=script&lang=js"

import "./ExistingClient.vue?vue&type=style&index=0&id=cff5cbaa&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cff5cbaa"]])

export default __exports__